module.exports = __webpack_public_path__ + "img/huntressLullaby.5fa218fa.png";